<template>
  <CDropdown
    inNav
    class="c-header-nav-items"
    placement="bottom-end"
    add-menu-classes="pt-0"
  >
    <template #toggler>
      <CHeaderNavLink>
        <div class="c-avatar">
          <img
            :src=auth.user.picture
            class="c-avatar-img "
          />
        </div>
      </CHeaderNavLink>
    </template>
    
    <CDropdownItem>
      <router-link to="/user-profile"><CIcon name="cil-lock-locked" /> User Profile</router-link>
    </CDropdownItem>

    <CDropdownItem v-on:click="logout">
      <CIcon name="cil-lock-locked" /> Logout
    </CDropdownItem>

  </CDropdown>
</template>

<script>
import { mapActions } from "vuex";

export default {

  data() {
    return {
      auth: {
        user: {}
      }
    };
  },
  async mounted() {
    await this.getUserData();
  },
  methods: {
    ...mapActions(["getLoggedInUser","logout"]),
    login() {
      // this.$auth.loginWithRedirect();
    },
    async getUserData() {
      this.auth.user = await this.getLoggedInUser();
    }
  }
};
</script>

<style scoped>
  .c-icon {
    margin-right: 0.3rem;
  }
</style>